/**
 * Created by Carsten Bühler
 * User: CBuehler on 14.07.2017
 * Copyright: xdot GmbH 2017
 */

import { Client } from 'external/lwr-client';
import { ApiUtil, AppContext } from 'plugin/liferay-widgets-react-web';
import { ClassNames, Services } from '../constants/Constants';

const subscriptionService = (m, o) => Client.invoke(Services[ClassNames.Subscription] + m, o);
const subscriptionServiceWithContext = (m, o, c) => Client.invokeWithContext(Services[ClassNames.Subscription] + m, o, c);

const api = {

    addCurrentAccountSubscription({ title, topic, channels = [] }){
        return subscriptionService('add-current-account-subscription.4', {
            title,
            topic,
            channels,
            createAccount: true
        }, {});
    },

    addOrUpdateOrDeleteMultiSubscription({ subscriptions = [] }){
        return subscriptionServiceWithContext('add-or-update-or-delete-multi-subscription.2', {
            createAccount: true
        }, {subscriptions});
    },

    updateSubscription({ uuid, title, topic, channels = [] }){
        return subscriptionService('update-subscription.4', {
            uuid,
            title,
            topic,
            channels
        });
    },

    delete(item){
        return subscriptionService('delete.1', {
            uuid: item.id
        });
    },

    deleteUserSubscription(item){
        return subscriptionService('delete-current-account-subscription-by-topic.1', {
            topic: item.topic
        });
    },

    findMySubscriptions(){
        return subscriptionService('get-current-account-subscriptions.0', {
            userId: AppContext.getUserId()
        });
    }
};

ApiUtil.namedApi('SubscriptionWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/SubscriptionWebApi.js